export class JobInformationClass {
    jobLanguage?: string;
    title?: string;
    jobType?: string[];
    description?: string;
    benefits?: string;
    placeOfWork?: string;
    startDate?: number;
}
